import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { theme } from '../Theme';

const pulse = keyframes`
  0% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.5);
  }
  100% {
    transform: scaleY(1);
  }
`;

const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  display: grid;
  grid-template-columns: repeat(auto-fill, 10px);
  grid-template-rows: repeat(auto-fill, 10px);
  justify-content: center;
  align-content: center;
  pointer-events: none; /* Allow clicks to pass through */
`;

const BinaryWrapper = styled.div`
  width: 10px;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CenterText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${theme.colors.secondary};
  font-size: 24px;
  display: flex;
  gap: 2px;
`;

const CenterLetter = styled.span`
  ${({ $animationSpeed }) =>
    $animationSpeed &&
    css`
      animation: ${pulse} ${$animationSpeed}s infinite ease-in-out;
    `}
`;

const Background = () => {
  const binaryCount = Math.floor(window.innerWidth / 10) * Math.floor(window.innerHeight / 10);
  const binaryValues = Array.from({ length: binaryCount }, () => (Math.random() > 0.5 ? '1' : '0'));

  const animationSpeed = 3; // Slow animation speed

  const letters = 'PLANETARIA RADIO'.split('');

  return (
    <BackgroundContainer>
      {Array.from({ length: binaryCount }).map((_, index) => (
        <BinaryWrapper key={index}>
          <div style={{ color: 'white', fontSize: '3px', fontFamily: 'inherit' }}>
            {binaryValues[index] || '0'}
          </div>
        </BinaryWrapper>
      ))}
      <CenterText>
        {letters.map((letter, index) => (
          <CenterLetter key={index} $animationSpeed={animationSpeed}>
            {letter}
          </CenterLetter>
        ))}
      </CenterText>
    </BackgroundContainer>
  );
};

export default Background;
